import { useEffect, useState } from "react";
import { getAll } from "../Utils/getAll";
import { syncUserPermissionsToStorage } from "../Utils/normalizePermissions";

const useUserPermissions = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    getAll((user) => {
      syncUserPermissionsToStorage(user);
      setReady(true);
    }, "user/get-user-profile");
  }, []);

  return ready;
};

export default useUserPermissions;
